export enum PuffsEnum {
  BLOG = 'blog',
  GUIDE = 'guide',
  NATIVE = 'native',
  PAGE = 'page',
  CARE_SERVICE_TYPE_PAGE = 'careServiceTypePage',
  SYMPTOM_PAGE = 'symptomPage',
}
